module.exports = __webpack_public_path__ + "static/media/vercel.169680e2.svg";